// Internal
import normalize from '~APP_UTIL/normalize';

// constants
const { createActionTypes } = normalize;

// Base
const BASENAME = 'GAMEDAY/ADMIN/';

// Types List
const types = ['SUBMIT_CATALOG_HEADERS'];

export default createActionTypes(types, BASENAME);
